type LegalPageProps = {
  kind: "terms" | "privacy";
};

const updatedAt = "28.7.2026";

function LegalHeader() {
  return (
    <>
      <div className="topline">
        <div className="container topline-inner">
          <span>RMK / Reilu metallikauppa</span>
          <span className="topline-trust">
            <i />
            Ei rekisteröitymistä
          </span>
        </div>
      </div>
      <header className="site-header legal-header">
        <div className="container header-inner">
          <a className="brand" href="/" aria-label="Romumetallikaupan etusivu">
            <span className="brand-mark">RMK</span>
            <span className="brand-name">Romumetallikauppa</span>
          </a>
          <a className="legal-back" href="/">
            ← Takaisin markkinapaikalle
          </a>
        </div>
      </header>
    </>
  );
}

function LegalFooter() {
  return (
    <footer className="legal-footer">
      <div className="container legal-footer-inner">
        <a className="brand brand-light" href="/">
          <span className="brand-mark">RMK</span>
          <span className="brand-name">Romumetallikauppa</span>
        </a>
        <div className="footer-legal-links">
          <a href="/kayttoehdot/">Käyttöehdot</a>
          <a href="/tietosuojaseloste/">Tietosuojaseloste</a>
        </div>
        <span>© {new Date().getFullYear()} Romumetallikauppa / RMK</span>
      </div>
    </footer>
  );
}

function Terms() {
  return (
    <>
      <section className="legal-hero">
        <div className="container legal-hero-inner">
          <span className="eyebrow">RMK / Palvelun pelisäännöt</span>
          <h1>Käyttöehdot</h1>
          <p>
            Selkeät ehdot metallierän ilmoittamiseen, tarjouksen tekemiseen ja
            kaupasta sopimiseen.
          </p>
          <small>Päivitetty {updatedAt}</small>
        </div>
      </section>

      <main className="container legal-layout">
        <aside className="legal-toc" aria-label="Sisällysluettelo">
          <strong>Sisältö</strong>
          <a href="#palvelu">1. Palvelun tarkoitus</a>
          <a href="#kayttaja">2. Käyttäjän vastuut</a>
          <a href="#ilmoitukset">3. Myynti-ilmoitukset</a>
          <a href="#tarjoukset">4. Tarjoukset ja kauppa</a>
          <a href="#turvallisuus">5. Turvallisuus</a>
          <a href="#oikeudet">6. Sisällön käyttöoikeus</a>
          <a href="#vastuu">7. Palvelun vastuu</a>
          <a href="#muutokset">8. Muutokset ja sovellettava laki</a>
        </aside>

        <article className="legal-content">
          <div className="legal-callout">
            <strong>Lyhyesti</strong>
            <p>
              RMK on ilmoitusalusta. Myyjä ja ostaja sopivat kaupasta suoraan
              keskenään, ja ilmoitus poistuu palvelusta automaattisesti viiden
              päivän kuluttua.
            </p>
          </div>

          <section id="palvelu" className="legal-section">
            <span>01</span>
            <div>
              <h2>Palvelun tarkoitus ja osapuolet</h2>
              <p>
                Näitä käyttöehtoja sovelletaan Romumetallikauppa-palvelun
                (”RMK” tai ”palvelu”) käyttöön. Julkaisemalla ilmoituksen,
                jättämällä tarjouksen tai muutoin käyttämällä palvelua käyttäjä
                hyväksyy nämä ehdot.
              </p>
              <p>
                RMK tarjoaa sähköisen ilmoitusalustan metallierien myyjille ja
                ostajille. RMK ei ole kaupan osapuoli, omista myytäviä eriä,
                tarkasta niiden laatua tai alkuperää, määritä hintaa, käsittele
                maksuja, järjestä kuljetusta eikä takaa kaupan toteutumista.
                Kauppa syntyy ja toteutetaan aina myyjän ja ostajan välillä.
              </p>
            </div>
          </section>

          <section id="kayttaja" className="legal-section">
            <span>02</span>
            <div>
              <h2>Käyttäjän vastuut</h2>
              <p>Käyttäjä vastaa siitä, että hän:</p>
              <ul>
                <li>
                  on täysi-ikäinen ja oikeustoimikelpoinen tai toimii
                  edustamansa yrityksen asianmukaisella valtuutuksella;
                </li>
                <li>
                  antaa oikeat ja ajantasaiset tiedot itsestään, erästä,
                  hinnasta, sijainnista ja yhteydenottotavasta;
                </li>
                <li>
                  omistaa myytävän materiaalin tai hänellä on oikeus myydä se;
                </li>
                <li>
                  kertoo ilmoituksessa selvästi, toimiiko hän
                  yksityishenkilönä vai yrityksenä; ja
                </li>
                <li>
                  noudattaa kaupankäyntiin, jätteisiin, verotukseen,
                  ympäristöön, kuljetukseen ja lupiin liittyvää lainsäädäntöä.
                </li>
              </ul>
            </div>
          </section>

          <section id="ilmoitukset" className="legal-section">
            <span>03</span>
            <div>
              <h2>Myynti-ilmoitukset</h2>
              <p>
                Ilmoituksen tulee kuvata erä rehellisesti ja riittävän
                täsmällisesti. Olennaiset tiedot, kuten materiaali, määrä,
                kunto, epäpuhtaudet, sijainti ja noutoon tai lastaukseen
                liittyvät ehdot, on kerrottava ennen kauppaa.
              </p>
              <p>
                Ilmoitus on näkyvissä enintään viisi päivää. RMK voi poistaa
                ilmoituksen tai rajoittaa sen näkyvyyttä, jos se on lain,
                näiden ehtojen tai hyvän tavan vastainen, harhaanjohtava,
                asiaton, vaarantaa palvelun turvallisuuden tai loukkaa
                ulkopuolisen oikeuksia.
              </p>
              <p>
                Palvelussa ei saa tarjota varastettua tai alkuperältään
                epäselvää materiaalia, laitonta tavaraa eikä vaarallista,
                räjähtävää, radioaktiivista tai paineistettua materiaalia ilman
                sen käsittelyyn vaadittavia oikeuksia ja tietoja. Roskaposti,
                haitallinen sisältö ja toisten henkilötietojen luvaton
                julkaiseminen on kielletty.
              </p>
            </div>
          </section>

          <section id="tarjoukset" className="legal-section">
            <span>04</span>
            <div>
              <h2>Tarjoukset, viestintä ja kaupan ehdot</h2>
              <p>
                Ostaja vastaa tarjouksensa ja yhteystietojensa oikeellisuudesta.
                Tarjouslomake tallentaa tarjouksen palveluun ja voi avata
                ostajan sähköpostiohjelman viestin lähettämistä varten.
                Ostajan tulee itse varmistaa viestin lähetys ja tarjouksen
                vastaanotto.
              </p>
              <p>
                Myyjän ja ostajan tulee sopia keskenään ainakin lopullisesta
                hinnasta, määrästä ja punnituksesta, maksutavasta,
                omistusoikeuden siirtymisestä, noudosta, lastauksesta,
                kuljetuksesta ja mahdollisista veroista. Sovitut ehdot
                kannattaa vahvistaa kirjallisesti.
              </p>
              <p>
                Yksityishenkilöiden väliseen kauppaan ei yleensä sovelleta
                kuluttajansuojalakia. Jos yritys myy kuluttajalle, pakottava
                kuluttajansuojalainsäädäntö on voimassa näistä ehdoista
                riippumatta. Lisätietoa saa{" "}
                <a
                  href="https://www.kkv.fi/kuluttaja-asiat/verkkokauppa/verkon-markkinapaikka-alustat/"
                  target="_blank"
                  rel="noreferrer"
                >
                  Kilpailu- ja kuluttajaviraston markkinapaikkaohjeesta
                </a>
                .
              </p>
            </div>
          </section>

          <section id="turvallisuus" className="legal-section">
            <span>05</span>
            <div>
              <h2>Turvallinen kaupankäynti</h2>
              <p>
                Osapuolten tulee arvioida vastapuoli, erän alkuperä, laatu,
                määrä ja mahdolliset käsittelyluvat ennen maksua tai luovutusta.
                Käyttäjän ei tule lähettää henkilöllisyystodistuksia,
                pankkitunnuksia tai muita tarpeettomia arkaluonteisia tietoja.
                Epäilyttävä tai kiireeseen painostava kaupankäynti kannattaa
                keskeyttää.
              </p>
            </div>
          </section>

          <section id="oikeudet" className="legal-section">
            <span>06</span>
            <div>
              <h2>Sisällön oikeudet</h2>
              <p>
                Käyttäjä säilyttää oikeutensa lisäämäänsä tekstiin ja kuvaan.
                Käyttäjä antaa RMK:lle maksuttoman, ei-yksinomaisen oikeuden
                tallentaa, käsitellä ja esittää sisältöä palvelun tarjoamiseksi,
                ilmoituksen näyttämiseksi ja väärinkäytösten estämiseksi.
                Oikeus päättyy, kun sisältö poistetaan, lukuun ottamatta
                välttämättömiä teknisiä tai lakisääteisiä säilytyksiä.
              </p>
            </div>
          </section>

          <section id="vastuu" className="legal-section">
            <span>07</span>
            <div>
              <h2>Palvelun saatavuus ja vastuu</h2>
              <p>
                Palvelu tarjotaan sellaisena kuin se kulloinkin on saatavilla.
                RMK ei takaa keskeytyksetöntä toimintaa, ilmoitusten tai
                käyttäjien oikeellisuutta, erän laatua, tarjouksen
                hyväksymistä, sähköpostin perillemenoa tai kaupan
                toteutumista.
              </p>
              <p>
                RMK ei vastaa myyjän ja ostajan välisen kaupan vahingoista,
                sopimusrikkomuksista tai käyttäjän palveluun lisäämästä
                sisällöstä. Vastuunrajoituksia ei sovelleta siltä osin kuin
                vastuu ei lain mukaan ole rajoitettavissa.
              </p>
            </div>
          </section>

          <section id="muutokset" className="legal-section">
            <span>08</span>
            <div>
              <h2>Muutokset, palvelun päättäminen ja sovellettava laki</h2>
              <p>
                RMK voi kehittää, keskeyttää tai lopettaa palvelun ja päivittää
                näitä ehtoja. Ajantasaiset ehdot julkaistaan tällä sivulla, ja
                olennainen muutos merkitään uudella päivityspäivällä.
              </p>
              <p>
                Ehtoihin sovelletaan Suomen lakia. Myyjän ja ostajan väliset
                erimielisyydet ratkaistaan ensisijaisesti osapuolten kesken.
                Kuluttajan pakottavia oikeuksia ja oikeutta saattaa asia
                toimivaltaisen viranomaisen tai tuomioistuimen käsiteltäväksi ei
                rajoiteta.
              </p>
            </div>
          </section>
        </article>
      </main>
    </>
  );
}

function Privacy() {
  return (
    <>
      <section className="legal-hero legal-hero-privacy">
        <div className="container legal-hero-inner">
          <span className="eyebrow">RMK / Henkilötietojen käsittely</span>
          <h1>Tietosuojaseloste</h1>
          <p>
            Mitä tietoja palvelu käyttää, miksi niitä tarvitaan ja milloin ne
            poistuvat.
          </p>
          <small>Päivitetty {updatedAt}</small>
        </div>
      </section>

      <main className="container legal-layout">
        <aside className="legal-toc" aria-label="Sisällysluettelo">
          <strong>Sisältö</strong>
          <a href="#rekisterinpitaja">1. Rekisterinpitäjä</a>
          <a href="#tiedot">2. Käsiteltävät tiedot</a>
          <a href="#tarkoitukset">3. Tarkoitukset ja perusteet</a>
          <a href="#julkisuus">4. Tietojen näkyminen</a>
          <a href="#sailytys">5. Säilytysajat</a>
          <a href="#palveluntarjoajat">6. Palveluntarjoajat</a>
          <a href="#evasteet">7. Evästeet ja analytiikka</a>
          <a href="#oikeutesi">8. Oikeutesi</a>
          <a href="#turva-ja-muutokset">9. Turvallisuus ja muutokset</a>
        </aside>

        <article className="legal-content">
          <div className="legal-callout">
            <strong>Yksityisyys pähkinänkuoressa</strong>
            <p>
              RMK:ssa ei ole käyttäjätilejä. Myynti-ilmoitukseen lisätyt
              yhteystiedot ovat julkisia, ja ilmoitus tietoineen poistuu
              automaattisesti viiden päivän kuluttua.
            </p>
          </div>

          <section id="rekisterinpitaja" className="legal-section">
            <span>01</span>
            <div>
              <h2>Rekisterinpitäjä ja selosteen soveltamisala</h2>
              <p>
                Rekisterinpitäjä on Romumetallikauppa (RMK). Tämä seloste koskee
                RMK:n myynti-ilmoitusten, tarjousten ja sivuston teknisen käytön
                yhteydessä käsiteltäviä henkilötietoja.
              </p>
            </div>
          </section>

          <section id="tiedot" className="legal-section">
            <span>02</span>
            <div>
              <h2>Käsiteltävät henkilötiedot</h2>
              <h3>Myynti-ilmoituksen tiedot</h3>
              <p>
                Nimi tai yrityksen nimi, puhelinnumero, sähköpostiosoite,
                paikkakunta, ilmoituksen otsikko, materiaali, määrä, hinta,
                kuvaus, kuva sekä julkaisu- ja päättymisaika.
              </p>
              <h3>Tarjouksen tiedot</h3>
              <p>
                Tarjoajan nimi, sähköpostiosoite, mahdollinen puhelinnumero,
                tarjoussumma, viesti, ilmoituksen tunniste ja tarjouksen
                ajankohta.
              </p>
              <h3>Tekniset tiedot</h3>
              <p>
                Palvelun toiminnan ja tietoturvan yhteydessä voidaan käsitellä
                IP-osoitetta, laitteen ja selaimen perustietoja, pyyntöjen
                ajankohtia sekä virhe- ja tietoturvalokeja. RMK ei luo
                käyttäjätilejä eikä tallenna salasanoja.
              </p>
            </div>
          </section>

          <section id="tarkoitukset" className="legal-section">
            <span>03</span>
            <div>
              <h2>Käsittelyn tarkoitukset ja oikeusperusteet</h2>
              <p>Tietoja käsitellään seuraaviin tarkoituksiin:</p>
              <ul>
                <li>
                  myynti-ilmoituksen julkaiseminen ja ostajien yhteydenottojen
                  mahdollistaminen;
                </li>
                <li>
                  tarjousten tallentaminen ja välittäminen ilmoituksen
                  yhteydessä;
                </li>
                <li>
                  palvelun tuottaminen, ylläpito, vianmääritys ja väärinkäytösten
                  ehkäisy; sekä
                </li>
                <li>lakisääteisten velvoitteiden hoitaminen.</li>
              </ul>
              <p>
                Myyjän ilmoitustietojen julkaiseminen ja tarjoajan tietojen
                käsittely perustuvat käyttäjän antamaan suostumukseen ja
                käyttäjän pyytämän palvelun toteuttamiseen. Palvelun
                tietoturvallinen ylläpito ja väärinkäytösten ehkäisy perustuvat
                RMK:n oikeutettuun etuun. Lakisääteisen velvoitteen
                täyttämiseksi tietoja käsitellään silloin, kun laki sitä vaatii.
              </p>
            </div>
          </section>

          <section id="julkisuus" className="legal-section">
            <span>04</span>
            <div>
              <h2>Tietojen julkisuus ja vastaanottajat</h2>
              <p>
                Myynti-ilmoituksen sisältö sekä myyjän ilmoitukseen lisäämät
                nimi-, puhelin- ja sähköpostitiedot näkyvät julkisesti kaikille
                sivuston kävijöille. Käyttäjän ei tule julkaista ilmoituksessa
                tarpeettomia henkilötietoja tai muiden henkilöiden tietoja.
              </p>
              <p>
                Tarjoajan tiedot eivät näy julkisessa ilmoituksessa. Ne
                tallennetaan tarjouksen yhteyteen, ja palvelu muodostaa niistä
                sähköpostiviestin myyjälle. Tarjoaja vastaa viestin
                lähettämisestä omassa sähköpostiohjelmassaan.
              </p>
            </div>
          </section>

          <section id="sailytys" className="legal-section">
            <span>05</span>
            <div>
              <h2>Säilytysajat</h2>
              <p>
                Myynti-ilmoitus, sen kuva, myyjän yhteystiedot ja ilmoitukseen
                liittyvät tarjoukset säilytetään enintään viisi päivää
                ilmoituksen julkaisemisesta. Tämän jälkeen tiedot poistuvat
                julkisesta palvelusta ja ne siivotaan automaattisesti RMK:n
                tietokannasta ja kuvatallennuksesta.
              </p>
              <p>
                Tietoturva- ja virhelokeja voidaan säilyttää rajatun ajan
                palvelun turvaamiseksi, ongelmien selvittämiseksi tai lain
                edellyttämässä laajuudessa. Palveluntarjoajat voivat säilyttää
                omia teknisiä lokitietojaan omien tietosuojakäytäntöjensä
                mukaisesti.
              </p>
            </div>
          </section>

          <section id="palveluntarjoajat" className="legal-section">
            <span>06</span>
            <div>
              <h2>Palveluntarjoajat ja tietojen siirrot</h2>
              <p>
                RMK käyttää sivuston, tietokannan ja kuvien tekniseen
                toteutukseen Cloudflaren palveluita (Pages, Workers, D1 ja R2).
                Cloudflare käsittelee tietoja palveluntarjoajana RMK:n lukuun.
                R2-kuvatallennus on määritetty EU-alueelle.
              </p>
              <p>
                Cloudflare voi käsitellä teknisiä tietoja myös EU- ja
                ETA-alueen ulkopuolella. Tällöin suojatoimina käytetään
                sovellettavan lainsäädännön mukaisia järjestelyjä, kuten
                Euroopan komission vakiolausekkeita. Lisätiedot löytyvät{" "}
                <a
                  href="https://www.cloudflare.com/policies/privacy/"
                  target="_blank"
                  rel="noreferrer"
                >
                  Cloudflaren tietosuojakäytännöstä
                </a>{" "}
                ja{" "}
                <a
                  href="https://www.cloudflare.com/cloudflare-customer-dpa/"
                  target="_blank"
                  rel="noreferrer"
                >
                  tietojenkäsittelyehdoista
                </a>
                .
              </p>
              <p>
                Kun tarjoaja lähettää muodostetun viestin sähköpostillaan,
                tarjoajan ja vastaanottajan sähköpostipalvelut käsittelevät
                viestiä omien ehtojensa ja tietosuojakäytäntöjensä mukaisesti.
              </p>
            </div>
          </section>

          <section id="evasteet" className="legal-section">
            <span>07</span>
            <div>
              <h2>Evästeet, analytiikka ja automaattinen päätöksenteko</h2>
              <p>
                RMK ei käytä käyttäjätilejä, markkinointievästeitä,
                käyttäytymiseen perustuvaa mainontaa eikä
                profilointia. Sivuston tekninen infrastruktuuri voi käyttää
                välttämättömiä tunnisteita ja lokitietoja turvallisuuden ja
                toiminnan varmistamiseksi.
              </p>
              <p>
                Henkilötietojen perusteella ei tehdä automatisoituja päätöksiä,
                joilla olisi käyttäjää koskevia oikeusvaikutuksia tai vastaavia
                merkittäviä vaikutuksia.
              </p>
            </div>
          </section>

          <section id="oikeutesi" className="legal-section">
            <span>08</span>
            <div>
              <h2>Rekisteröidyn oikeudet</h2>
              <p>
                Soveltuvan tietosuojalainsäädännön mukaisesti käyttäjällä voi
                olla oikeus tarkastaa itseään koskevat tiedot, pyytää niiden
                oikaisua tai poistamista, rajoittaa käsittelyä, vastustaa
                käsittelyä ja saada itse toimittamansa tiedot siirrettyä.
                Suostumuksen voi peruuttaa milloin tahansa, eikä peruuttaminen
                vaikuta sitä edeltäneen käsittelyn lainmukaisuuteen.
              </p>
              <p>
                Oikeuspyynnössä käyttäjän tulee yksilöidä ilmoitus tai tarjous
                ja varautua osoittamaan, että pyyntö koskee hänen omia
                tietojaan. Käyttäjällä on myös oikeus tehdä valitus{" "}
                <a href="https://tietosuoja.fi/" target="_blank" rel="noreferrer">
                  Tietosuojavaltuutetun toimistolle
                </a>
                .
              </p>
            </div>
          </section>

          <section id="turva-ja-muutokset" className="legal-section">
            <span>09</span>
            <div>
              <h2>Tietoturva ja selosteen muutokset</h2>
              <p>
                RMK suojaa tietoja teknisin ja organisatorisin toimin, kuten
                salatulla verkkoyhteydellä, käyttöoikeuksien rajauksilla,
                syötteiden tarkistuksilla ja automaattisilla poistoajoilla.
                Mikään verkkopalvelu ei kuitenkaan ole täysin riskitön, joten
                ilmoitukseen tulee lisätä vain kaupankäynnin kannalta
                tarpeelliset tiedot.
              </p>
              <p>
                Tätä selostetta päivitetään palvelun tai käsittelytapojen
                muuttuessa. Ajantasainen versio ja päivityspäivä julkaistaan
                tällä sivulla.
              </p>
            </div>
          </section>
        </article>
      </main>
    </>
  );
}

export default function LegalPage({ kind }: LegalPageProps) {
  return (
    <div className="legal-page">
      <LegalHeader />
      {kind === "terms" ? <Terms /> : <Privacy />}
      <LegalFooter />
    </div>
  );
}
